import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";

import { cn } from "@krea/shared/utils";

interface ISliderProps
  extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  trackClassName?: string;
}

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  ISliderProps
>(({ className, trackClassName, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      "[&>span:has([role=slider])]:z-10",
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track
      className={cn(
        "group relative z-0 h-[14px] w-full min-w-0 grow cursor-pointer overflow-hidden rounded-full",
      )}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0 rounded-full bg-white"
      />
      <div
        aria-hidden
        className={cn(
          "pointer-events-none absolute inset-0 z-[1] rounded-full bg-primary-150 transition-colors duration-300 ease-in-out group-hover:bg-primary/10 group-active:bg-primary/10",
          trackClassName,
        )}
      />
      <SliderPrimitive.Range className="absolute z-[2] h-full min-w-0 bg-primary" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block box-border h-8 w-8 cursor-grab rounded-full border-solid border-[12px] border-primary bg-white ring-offset-white transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
